import { render, staticRenderFns } from "./FinalPonderation.vue?vue&type=template&id=2cebb86f&"
import script from "./FinalPonderation.vue?vue&type=script&lang=js&"
export * from "./FinalPonderation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports